import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["box", "count"]
  static values = { autosaveUrl: String }

  connect() {
    this.refresh()
  }

  toggle(event) {
    this.refresh()
    this.persist(event.target)
  }

  clear() {
    this.boxTargets.forEach((box) => {
      if (!box.checked) return
      box.checked = false
      this.persist(box)
    })
    this.refresh()
  }

  refresh() {
    if (!this.hasCountTarget) return
    const count = this.boxTargets.filter((box) => box.checked).length
    const template = this.countTarget.dataset.template || "Errors: %{count}"
    this.countTarget.textContent = template.replace("%{count}", String(count))
  }

  persist(box) {
    if (!box || !this.hasAutosaveUrlValue || !this.autosaveUrlValue) return
    const questionNumber = box.dataset.questionNumber
    if (!questionNumber) return
    const token = document.querySelector("meta[name='csrf-token']")?.content
    const body = new URLSearchParams()
    body.set("question_number", questionNumber)
    body.set("value", box.checked ? "1" : "0")
    try {
      fetch(this.autosaveUrlValue, {
        method: "POST",
        body,
        keepalive: true,
        credentials: "same-origin",
        headers: {
          "X-CSRF-Token": token || "",
          Accept: "application/json"
        }
      }).catch(() => {})
    } catch (_error) {
      // a missed autosave still leaves the checkbox in the submit payload
    }
  }
}
